// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IRegistrationUseType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class RegistrationUseType implements IRegistrationUseType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Farm Commercial Non-Permanent Trailer RegistrationUseType
	**/
    get FarmCommercialNonPermanentTrailer(): IRegistrationUseType {
        return this.FromId(34);
    }
    /**
		Returns Regular RegistrationUseType
	**/
    get Regular(): IRegistrationUseType {
        return this.FromId(1);
    }
    /**
		Returns Commercial RegistrationUseType
	**/
    get Commercial(): IRegistrationUseType {
        return this.FromId(2);
    }
    /**
		Returns Commercial Non-Permanent Trailer RegistrationUseType
	**/
    get CommercialNonPermanentTrailer(): IRegistrationUseType {
        return this.FromId(3);
    }
    /**
		Returns Commercial - Limited Mileage < 2000 RegistrationUseType
	**/
    get CommercialLimitedMileage2000(): IRegistrationUseType {
        return this.FromId(4);
    }
    /**
		Returns Commercial - Limited Mileage  2000 - 4000 RegistrationUseType
	**/
    get CommercialLimitedMileage20004000(): IRegistrationUseType {
        return this.FromId(5);
    }
    /**
		Returns Rental (Allocated) RegistrationUseType
	**/
    get RentalAllocated(): IRegistrationUseType {
        return this.FromId(6);
    }
    /**
		Returns Taxi RegistrationUseType
	**/
    get Taxi(): IRegistrationUseType {
        return this.FromId(7);
    }
    /**
		Returns Farm RegistrationUseType
	**/
    get Farm(): IRegistrationUseType {
        return this.FromId(8);
    }
    /**
		Returns Commercial - One Way Hauling RegistrationUseType
	**/
    get CommercialOneWayHauling(): IRegistrationUseType {
        return this.FromId(9);
    }
    /**
		Returns Commercial - Route Truck RegistrationUseType
	**/
    get CommercialRouteTruck(): IRegistrationUseType {
        return this.FromId(10);
    }
    /**
		Returns Commercial - Agriculture Use RegistrationUseType
	**/
    get CommercialAgricultureUse(): IRegistrationUseType {
        return this.FromId(11);
    }
    /**
		Returns Non-Government Emergency Service RegistrationUseType
	**/
    get NonGovernmentEmergencyService(): IRegistrationUseType {
        return this.FromId(12);
    }
    /**
		Returns Primarily Off Highway Vehicle RegistrationUseType
	**/
    get PrimarilyOffHighwayVehicle(): IRegistrationUseType {
        return this.FromId(13);
    }
    /**
		Returns Off Road RegistrationUseType
	**/
    get OffRoad(): IRegistrationUseType {
        return this.FromId(14);
    }
    /**
		Returns Commercial - Seasonal Agriculture Registration RegistrationUseType
	**/
    get CommercialSeasonalAgricultureRegistration(): IRegistrationUseType {
        return this.FromId(16);
    }
    /**
		Returns Farm - Seasonal Agriculture Registration (SAR) RegistrationUseType
	**/
    get FarmSeasonalAgricultureRegistrationSAR(): IRegistrationUseType {
        return this.FromId(17);
    }
    /**
		Returns Interstate Vehicle RegistrationUseType
	**/
    get InterstateVehicle(): IRegistrationUseType {
        return this.FromId(18);
    }
    /**
		Returns Interstate - One Way Hauling RegistrationUseType
	**/
    get InterstateOneWayHauling(): IRegistrationUseType {
        return this.FromId(19);
    }
    /**
		Returns Interstate - Route Truck RegistrationUseType
	**/
    get InterstateRouteTruck(): IRegistrationUseType {
        return this.FromId(20);
    }
    /**
		Returns Interstate - Agriculture Use RegistrationUseType
	**/
    get InterstateAgricultureUse(): IRegistrationUseType {
        return this.FromId(21);
    }
    /**
		Returns Commercial Permanent Trailer RegistrationUseType
	**/
    get CommercialPermanentTrailer(): IRegistrationUseType {
        return this.FromId(24);
    }
    /**
		Returns Non-Commercial Permanent Trailer RegistrationUseType
	**/
    get NonCommercialPermanentTrailer(): IRegistrationUseType {
        return this.FromId(25);
    }
    /**
		Returns Commercial - For Hire RegistrationUseType
	**/
    get CommercialForHire(): IRegistrationUseType {
        return this.FromId(26);
    }
    /**
		Returns Non - Commercial Trailer RegistrationUseType
	**/
    get NonCommercialTrailer(): IRegistrationUseType {
        return this.FromId(27);
    }
    /**
		Returns Government RegistrationUseType
	**/
    get Government(): IRegistrationUseType {
        return this.FromId(28);
    }
    /**
		Returns Primarily On Highway Vehicle RegistrationUseType
	**/
    get PrimarilyOnHighwayVehicle(): IRegistrationUseType {
        return this.FromId(32);
    }
    /**
		Returns Rental RegistrationUseType
	**/
    get Rental(): IRegistrationUseType {
        return this.FromId(33);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('34', { id: 34, value: 'FarmCommercialNonPermanentTrailer', displayValue: 'Farm Commercial Non-Permanent Trailer', description: 'Farm Commercial Non-Permanent Trailer', sortOrder: 99999, active: true });
        this._dictionary.add('1', { id: 1, value: 'Regular', displayValue: 'Regular', description: 'Regular', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, value: 'Commercial', displayValue: 'Commercial', description: 'Commercial', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: 'CommercialNon-PermanentTrailer', displayValue: 'Commercial Non-Permanent Trailer', description: 'Commercial Non-Permanent Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: 'Commercial-LimitedMileage<2000', displayValue: 'Commercial - Limited Mileage < 2000', description: 'Commercial - Limited Mileage < 2000', sortOrder: 999999, active: true });
        this._dictionary.add('5', { id: 5, value: 'Commercial-LimitedMileage2000-4000', displayValue: 'Commercial - Limited Mileage  2000 - 4000', description: 'Commercial - Limited Mileage  2000 - 4000', sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, value: 'Rental(Allocated)', displayValue: 'Rental (Allocated)', description: 'Rental (Allocated)', sortOrder: 999999, active: true });
        this._dictionary.add('7', { id: 7, value: 'Taxi', displayValue: 'Taxi', description: 'Taxi', sortOrder: 999999, active: false });
        this._dictionary.add('8', { id: 8, value: 'Farm', displayValue: 'Farm', description: 'Farm', sortOrder: 999999, active: true });
        this._dictionary.add('9', { id: 9, value: 'Commercial-OneWayHauling', displayValue: 'Commercial - One Way Hauling', description: 'Commercial - One Way Hauling', sortOrder: 999999, active: true });
        this._dictionary.add('10', { id: 10, value: 'Commercial-RouteTruck', displayValue: 'Commercial - Route Truck', description: 'Commercial - Route Truck', sortOrder: 999999, active: true });
        this._dictionary.add('11', { id: 11, value: 'Commercial-AgricultureUse', displayValue: 'Commercial - Agriculture Use', description: 'Commercial - Agriculture Use', sortOrder: 999999, active: true });
        this._dictionary.add('12', { id: 12, value: 'Non-GovernmentEmergencyService', displayValue: 'Non-Government Emergency Service', description: 'Non-Government Emergency Service', sortOrder: 999999, active: true });
        this._dictionary.add('13', { id: 13, value: 'PrimarilyOffHighwayVehicle', displayValue: 'Primarily Off Highway Vehicle', description: 'Primarily Off Highway Vehicle', sortOrder: 999999, active: true });
        this._dictionary.add('14', { id: 14, value: 'OffRoad', displayValue: 'Off Road', description: 'Off Road', sortOrder: 999999, active: true });
        this._dictionary.add('16', { id: 16, value: 'Commercial-SeasonalAgricultureRegistration', displayValue: 'Commercial - Seasonal Agriculture Registration', description: 'Commercial - Seasonal Agriculture Registration (SAR)', sortOrder: 999999, active: true });
        this._dictionary.add('17', { id: 17, value: 'Farm-SeasonalAgricultureRegistration(SAR)', displayValue: 'Farm - Seasonal Agriculture Registration (SAR)', description: 'Farm - Seasonal Agriculture Registration (SAR)', sortOrder: 999999, active: true });
        this._dictionary.add('18', { id: 18, value: 'InterstateVehicle', displayValue: 'Interstate Vehicle', description: 'Interstate Vehicle', sortOrder: 999999, active: true });
        this._dictionary.add('19', { id: 19, value: 'Interstate-OneWayHauling', displayValue: 'Interstate - One Way Hauling', description: 'Interstate - One Way Hauling', sortOrder: 999999, active: true });
        this._dictionary.add('20', { id: 20, value: 'Interstate-RouteTruck', displayValue: 'Interstate - Route Truck', description: 'Interstate - Route Truck', sortOrder: 999999, active: true });
        this._dictionary.add('21', { id: 21, value: 'Interstate-AgricultureUse', displayValue: 'Interstate - Agriculture Use', description: 'Interstate - Agriculture Use', sortOrder: 999999, active: true });
        this._dictionary.add('24', { id: 24, value: 'CommercialPermanentTrailer', displayValue: 'Commercial Permanent Trailer', description: 'Commercial Permanent Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('25', { id: 25, value: 'Non-CommercialPermanentTrailer', displayValue: 'Non-Commercial Permanent Trailer', description: 'Non-Commercial Permanent Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('26', { id: 26, value: 'Commercial-ForHire', displayValue: 'Commercial - For Hire', description: 'Commercial - For Hire', sortOrder: 999999, active: true });
        this._dictionary.add('27', { id: 27, value: 'Non-CommercialTrailer', displayValue: 'Non - Commercial Trailer', description: 'Non - Commercial Trailer', sortOrder: 999999, active: false });
        this._dictionary.add('28', { id: 28, value: 'Government', displayValue: 'Government', description: 'Government', sortOrder: 999999, active: true });
        this._dictionary.add('32', { id: 32, value: 'PrimarilyOnHighwayVehicle', displayValue: 'Primarily On Highway Vehicle', description: 'Primarily On Highway Vehicle', sortOrder: 999999, active: true });
        this._dictionary.add('33', { id: 33, value: 'Rental', displayValue: 'Rental', description: 'Rental', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IRegistrationUseType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IRegistrationUseType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IRegistrationUseType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IRegistrationUseType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IRegistrationUseType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
